import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/perfilacessousuario/';

class PerfilAcessoUsuarioService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }

    findAllByUsuarioContr(idCliente, idUsuario, idContribuinte) {
        return axios.get(API_URL + 'all?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, {headers: this.headers});
    }

    findAllByUsuarioFisc(idCliente, idUsuario) {
        return axios.get(API_URL + 'allFiscal?idCliente='+idCliente+'&idUsuario='+idUsuario, {headers: this.headers});
    }
    
    save(idUsuario, idContribuinte, perfisAcesso) {
        return axios.post(API_URL+'?idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, JSON.stringify(perfisAcesso),
        {headers: this.headers});
    }

    saveFiscal(idUsuario, perfisAcesso) {
        return axios.post(API_URL+'saveFiscal?idUsuario='+idUsuario, JSON.stringify(perfisAcesso),
        {headers: this.headers});
    }


}

export default new PerfilAcessoUsuarioService();